import { render, staticRenderFns } from "./RemoveLawyerChildStep.vue?vue&type=template&id=89346b28"
import script from "./RemoveLawyerChildStep.vue?vue&type=script&lang=ts"
export * from "./RemoveLawyerChildStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports